import React from 'react';
import styles from './labels.scss';

interface ITag {
  className?: string;
  text: React.ReactNode;
}

interface IButtonTagWithLabel extends ITag {
  tagClassName?: string;
  label?: string;
}

export const NewLabel = ({ className }) => (
  <span className={classnames(styles.new, className)}>NEW</span>
);

export const Tag = ({ className, text }: ITag) => (
  <span className={classnames(styles.tag, className)}>{text}</span>
);

export const BlueTag = ({ className, text }: ITag) => (
  <Tag className={classnames(styles.blue, className)} text={text} />
);

export const ButtonTag = ({ className, text }: ITag) => (
  <div className={classnames(styles.buttonTag, className)}>{text}</div>
);

export const ButtonTagWithLabel = ({
  className,
  tagClassName,
  label,
  text,
}: IButtonTagWithLabel) => (
  <div className={classnames(styles.buttonTagWithLabel, className)}>
    {label && <div className={styles.label}>{label}</div>}
    <ButtonTag className={tagClassName} text={text} />
  </div>
);
